export type SafetySeverity = "none" | "info" | "caution" | "danger";
export type SafetyState = "clear" | "flagged" | "no-data";
export type SafetyDataState = "present" | "missing" | "stale";
export type SafetyHazard = { severity: SafetySeverity; label: string };

export type SafetyHeadsUpInput = {
  hazards: SafetyHazard[];
  dataState?: SafetyDataState;
  checksIncomplete?: boolean;
};

export type SafetyHeadsUpModel = {
  state: SafetyState;
  severity: SafetySeverity;
  headline: string;
  autoExpand: boolean;
};

const RANK: Record<SafetySeverity, number> = { none: 0, info: 1, caution: 2, danger: 3 };

export function resolveSafety(input?: SafetyHeadsUpInput): SafetyHeadsUpModel {
  if (!input || input.dataState === "missing" || input.dataState === "stale") {
    return {
      state: "no-data",
      severity: "info",
      headline: "Safety data unavailable",
      autoExpand: false,
    };
  }

  const worst = input.hazards.reduce<SafetyHazard | null>(
    (acc, h) => (acc && RANK[acc.severity] >= RANK[h.severity] ? acc : h),
    null
  );
  if (!worst || worst.severity === "none") {
    return {
      state: "clear",
      severity: "none",
      headline: "No PeakWave hazards flagged",
      autoExpand: false,
    };
  }
  return {
    state: "flagged",
    severity: worst.severity,
    headline: worst.label,
    autoExpand: RANK[worst.severity] >= RANK.caution,
  };
}
